/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
declare let i18nMgr: any;
const ServerError = {
  en: {
    [1]: 'system error', // "系统错误",
    [2]: 'User is already online', // "用户已经在线",
    [3]: 'User has not logged in', // "用户没有登录过",
    [4]: 'Invalid client request', // "客户端请求无效",
    [5]: 'No location', // "没有位置信息",
    [6]: 'Location information', // "有位置信息",
    [7]: 'Insufficient balance for this table, please recharge.', // "筹码不足",
    [8]: 'Already in the game', // "已经在游戏中",
    [9]: 'No product', // "没有产品",
    [10]: 'Game does not exist', // "游戏不存在",
    [11]: 'Server connection is busy, please try again', // "游戏服务器不存在",
    [12]: 'Table does not exist', // "桌子不存在",
    [13]: 'Table number already exists', // "桌号已经存在",
    [14]: 'Incorrect seat number', // "座位号错误",
    [15]: 'Failed to create table', // "创建桌子失败",
    [16]: 'Invalid password', // "密码无效",
    [17]: "The client's unique identifier is empty", // "客户端唯一标识空",
    [18]: 'User does not exist', // "用户不存在",
    [19]: 'User in game', // "用户在游戏中",
    [20]: 'E020', // "机器人不在需要",
    [21]: 'Seat number has been used', // "座位号已经被使用",
    [22]: 'Verification code error!', // "短信验证码错误",
    [23]: 'Automatically recharge chips to enter and carry', // "自动将筹码充值到进场携带中",
    [24]: 'Automatic table change', // "自动换桌",
    [25]: 'TOKEN expired', // "TOKEN过期",
    [26]: 'No enough chips!', // "金币不足",
    [27]: 'Withdrawal restrictions', // 提现限制
    [28]: 'Request failed', // "请求失败",
    [29]: 'Client mark error', // "客户端mark错误",
    [30]: 'Your account has been locked!', // "不在白名单中",
    [31]: 'Invalid nickname length',
    [32]: 'User does not exist',
    [33]: 'Name occupied,fill in again please',
    [34]: 'Invalid invitation code', // 推荐人ID不存在
    [35]: 'Token is invalid.35', // Token为空",
    [36]: 'Token is invalid.36', // "Token无效",
    [37]: 'Account has been banned, please contact customer service', // "用户被封号",
    [38]: 'IP Limited', // IP受限
    [39]: 'Successful invitation code binding', // 已经设置过了
    [40]: 'Withdrawal failed: 40', // 提现类型错误
    [41]: "Sorry you didn't get the lottery ticket. Move on to the next turn!", // 库存不足
    [42]: 'E042', // 正在开奖
    [43]: 'E043', // 未进行KYC认证
    [44]: 'You have reached the betting limit',
    [45]: 'This icon has been set', // 已是当前头像
    [48]: 'Players are locked in.Game is about to begin.',
    [49]: 'Players are locked in.Game is about to begin.',
    [54]: 'Please wait for the decaleration of all players.',
    [55]: 'Only 2 accounts can be registered for one device.',
    [120]: 'Game server disconnection', //游戏服务器断线
    [130]: 'System Maintenance', //系统维护
    [131]: 'Player check-in activity channel mismatch', //玩家签到活动渠道不匹配
    [132]: 'Players are unable to participate in check-in activities', //玩家无法参与签到活动
    [133]: 'The betting limit for the number you have selected has been reached.',
    [134]: 'The user already exists', // 用户已存在
    [135]: 'Already bound phone number', // 已绑定手机号
    [136]: 'Password error', // 密码错误
    [137]: 'Bet failed', // CP2/3D下注失败
  },
  tr: {
    [1]: 'system error', // "系统错误",
  },
  my: {
    [1]: 'စနစ်အမှား',
    [2]: 'အသုံးပြုသူသည် အွန်လိုင်းတွင်ရှိပြီးသား',
    [3]: 'အသုံးပြုသူသည် ဝင်ရောက်ခဲ့သည်မဟုတ်',
    [4]: 'မတရားသော client တောင်းဆိုချက်',
    [5]: 'နေရာမရှိဘူး',
    [6]: 'တည်နေရာအချက်အလက်',
    [7]: 'ဤစားပွဲအတွက် မလုံလောက်သော ဟန်ချက်မျှမှု, ကျေးဇူးပြု၍ ပြန်လည်အားသွင်းပါ။',
    [8]: 'ဂိမ်းထဲမှာရှိပြီးသား',
    [9]: 'ထုတ်ကုန်မရှိဘူး',
    [10]: 'ဂိမ်းမရှိဘူး',
    [11]: 'ဆာဗာချိတ်ဆက်မှုသည် အလုပ်ဝင်သည်, ကျေးဇူးပြု၍ ပြန်လည်ကြိုးစားပါ',
    [12]: 'စားပွဲမရှိဘူး',
    [13]: 'စားပွဲနံပါတ်ရှိပြီးသားပြီ',
    [14]: 'မှားယွင်းသော ထိုင်ခုံနံပါတ်',
    [15]: 'စားပွဲဖန်တီးခြင်းတွင် ပျက်စီးခဲ့သည်',
    [16]: 'မတရားသော စကားဝှက်',
    [17]: 'ဖောက်သည်၏ ထူးခြားသော အမှတ်တံဆိပ်သည် လွတ်လပ်သည်',
    [18]: 'အသုံးပြုသူမရှိဘူး',
    [19]: 'ဂိမ်းတွင်အသုံးပြုသူ',
    [20]: 'E020',
    [21]: 'ထိုင်ခုံနံပါတ်ကို အသုံးပြုခဲ့သည်',
    [22]: 'အတည်ပြုမှုကုဒ်အမှား!',
    [23]: 'ဝင်ပြီး သယ်ဆောင်ရန် ချစ်ပ်များကို အလိုအလျောက် ပြန်အားသွင်းပါ',
    [24]: 'အလိုအလျောက်စားပွဲပြောင်းလဲခြင်း',
    [25]: 'TOKEN ကုန်သတ်မှတ်ခဲ့သည်',
    [26]: 'ချစ်ပ်စ်များ မလုံလောက်ဘူး။',
    [27]: 'ထုတ်ယူမှုကန့်သတ်ချက်များ',
    [28]: 'တောင်းဆိုမှုပျက်စီးခဲ့သည်',
    [29]: 'ဖောက်သည်အမှတ်တံဆိပ်အမှား',
    [30]: 'သင့်အကောင့်ကို ပိတ်ထားပါတယ်။',
    [31]: 'မတရားသော အမည်ခေါ်အရှည်',
    [32]: 'အသုံးပြုသူမရှိဘူး',
    [33]: 'အမည်ကို သိမ်းဆည်း, ကျေးဇူးပြု၍ ထပ်ဖြည့်ပါ',
    [34]: 'မတရားသော ဖိတ်ခေါ်မှုကုဒ်',
    [35]: 'Token သည် မတရားပါ။ ၃၅',
    [36]: 'Token သည် မတရားပါ။၃၆',
    [37]: 'အကောင့်ကို တားမြစ်ထားပြီး ကျေးဇူးပြု၍ ဖောက်သည်ဝန်ဆောင်မှုကို ဆက်သွယ်ပါ',
    [38]: 'IP လီမိတက်',
    [39]: 'အောင်မြင်သော ဖိတ်ခေါ်မှုကုဒ်ချိတ်ဆက်ခြင်း',
    [40]: 'ထုတ်ယူမှုပျက်စီးခဲ့သည်: ၄၀',
    [41]: 'ပွဲလက်မှတ်မရဘူးဆိုတာ စိတ်မကောင်းပါဘူး။ နောက်လမ်းကို ရွှေ့ပါ။',
    [42]: 'E042',
    [43]: 'E043',
    [44]: 'သင်ဟာ လောင်းကစားမှု ကန့်သတ်ချက်ကို ရောက်ရှိခဲ့တယ်',
    [45]: 'ဤအိုင်ကွန်ကို သတ်မှတ်ထားသည်',
    [48]: 'ကစားသမားများသည် ပိတ်ထားသည်။ ဂိမ်းသည် စတင်မည်ဖြစ်သည်။',
    [49]: 'ကစားသမားများသည် ပိတ်ထားသည်။ ဂိမ်းသည် စတင်မည်ဖြစ်သည်။',
    [54]: 'ကစားသမားအားလုံးရဲ့ အရှိန်ကျမှုကို စောင့်ဆိုပါ။',
    [55]: 'ကိရိယာတစ်ခုအတွက် အကောင့် ၂ ခုသာ မှတ်ပုံတင်နိုင်သည်။',
    [120]: 'ဂိမ်းဆာဗာချိတ်ဆက်ခြင်း',
    [130]: 'စနစ်ထိန်းသိမ်းမှု',
    [131]: 'ကစားသမား check-in လုပ်ဆောင်မှုလမ်းကြောင်းမကိုက်ညီမှု',
    [132]: 'ကစားသမားများသည် စစ်ဆေးမှုလုပ်ဆောင်ချက်များတွင် ပါဝင်နိုင်ခြင်းမရှိပါ',
    [133]: 'သင်ရွေးချယ်ထားသော နံပါတ်အတွက် လောင်းကစားကန့်သတ်ချက်ကို ရောက်ရှိခဲ့သည်။',
    [134]: 'အသုံးပြုသူသည် တည်ရှိပြီးသား',
    [135]: 'ဖုန်းနံပါတ်ကို ချိတ်ထားပြီးသား',
    [136]: 'စကားဝှက်အမှား',
    [137]: 'လောင်းကစားမှုပျက်စီးခဲ့သည်',
  },
  pak: {
    [1]: 'نظام کی غلطی', // "系统错误",
    [2]: 'User is already online', // "用户已经在线",
    [3]: 'User has not logged in', // "用户没有登录过",
    [4]: 'Invalid client request', // "客户端请求无效",
    [5]: 'No location', // "没有位置信息",
    [6]: 'Location information', // "有位置信息",
    [7]: 'Insufficient balance for this table, please recharge.', // "筹码不足",
    [8]: 'Already in the game', // "已经在游戏中",
    [9]: 'No product', // "没有产品",
    [10]: 'Game does not exist', // "游戏不存在",
    [11]: 'Server connection is busy, please try again', // "游戏服务器不存在",
    [12]: 'Table does not exist', // "桌子不存在",
    [13]: 'Table number already exists', // "桌号已经存在",
    [14]: 'Incorrect seat number', // "座位号错误",
    [15]: 'Failed to create table', // "创建桌子失败",
    [16]: 'Invalid password', // "密码无效",
    [17]: "The client's unique identifier is empty", // "客户端唯一标识空",
    [18]: 'User does not exist', // "用户不存在",
    [19]: 'User in game', // "用户在游戏中",
    [20]: 'E020', // "机器人不在需要",
    [21]: 'Seat number has been used', // "座位号已经被使用",
    [22]: 'Verification code error!', // "短信验证码错误",
    [23]: 'Automatically recharge chips to enter and carry', // "自动将筹码充值到进场携带中",
    [24]: 'Automatic table change', // "自动换桌",
    [25]: 'TOKEN expired', // "TOKEN过期",
    [26]: 'No enough chips!', // "金币不足",
    [27]: 'Withdrawal restrictions', // 提现限制
    [28]: 'Request failed', // "请求失败",
    [29]: 'Client mark error', // "客户端mark错误",
    [30]: 'Your account has been locked!', // "不在白名单中",
    [31]: 'Invalid nickname length',
    [32]: 'User does not exist',
    [33]: 'Name occupied,fill in again please',
    [34]: 'Invalid invitation code', // 推荐人ID不存在
    [35]: 'Token is invalid.35', // Token为空",
    [36]: 'Token is invalid.36', // "Token无效",
    [37]: 'Account has been banned, please contact customer service', // "用户被封号",
    [38]: 'IP Limited', // IP受限
    [39]: 'Successful invitation code binding', // 已经设置过了
    [40]: 'Withdrawal failed: 40', // 提现类型错误
    [41]: "Sorry you didn't get the lottery ticket. Move on to the next turn!", // 库存不足
    [42]: 'E042', // 正在开奖
    [43]: 'E043', // 未进行KYC认证
    [44]: 'You have reached the betting limit',
    [45]: 'This icon has been set', // 已是当前头像
    [48]: 'Players are locked in.Game is about to begin.',
    [49]: 'Players are locked in.Game is about to begin.',
    [54]: 'Please wait for the decaleration of all players.',
    [55]: 'Only 2 accounts can be registered for one device.',
    [120]: 'Game server disconnection', //游戏服务器断线
    [130]: 'System Maintenance', //系统维护
    [131]: 'Player check-in activity channel mismatch', //玩家签到活动渠道不匹配
    [132]: 'Players are unable to participate in check-in activities', //玩家无法参与签到活动
    [133]: 'The betting limit for the number you have selected has been reached.',
    [134]: 'The user already exists', // 用户已存在
    [135]: 'Already bound phone number', // 已绑定手机号
    [136]: 'Password error', // 密码错误
    [137]: 'Bet failed', // CP2/3D下注失败
  },
}

export function serverErrorMsg(code: number, msg?: string) {
  let value = ServerError['en'][code]
  const lanCode = i18nMgr.getLanguage()
  if (lanCode != 'en') {
    const values = ServerError[lanCode]
    if (values != undefined && values[code] != undefined) {
      value = values[code]
    }
  }

  const msg_ = value || msg || 'Unknown error'
  return msg_
}
